module.exports = __webpack_public_path__ + "img/128x128_star_black_hole.509979f6.svg";